import {useEffect} from "react";
import IconNav from './IconNav';
import styled from 'styled-components';
import { up } from 'styled-breakpoints';
import MenuCreate from "./MenuCreate";
import MenuItemCreate from './MenuItemCreate';
import FormContainer from './FormContainer';
import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import { useLocation, useNavigate } from "react-router";

const IconNavWrap = styled.div`
    width: 80%;
    margin: 0 auto;
    display: block;
    margin-bottom: 2em;

    ${up('xs')} {
        width: 50%;
    }

    ${up('sm')} {
        width:40%;
    }

    ${up('md')} {
        width:35%;
    }

    ${up('xl')} {
        width:30%;
    }

    ${up('xxl')} {
        width:20%;
    }

    ${up('giant')} {
        width:15%;
    }

`;

function VisualMenuBuilder(props) {
  const location = useLocation();
  const navigate = useNavigate();

  if (location.pathname === "/menu-builder/visual-menu") {
    navigate("/menu-builder/visual-menu/create-menu");
  }

  useEffect(() => {
    props.setHeader("Visual menu builder");
    props.setSubheader("Start building your visual menu by adding your first menu");
  });

  return (
    <>
      <IconNavWrap>
        <IconNav />
      </IconNavWrap>
      <FormContainer>
        <Outlet />
      </FormContainer>
    </>
  );
}

export default VisualMenuBuilder;
